// extracted by mini-css-extract-plugin
module.exports = {"row":"AssetReport_row__1Yq08","left":"AssetReport_left__2LzNS","icon":"AssetReport_icon__3JlXA","right":"AssetReport_right__3uTbg","dowload":"AssetReport_dowload__388-r"};